const fmt = require("indian-number-format");

export default function TotalCard({
  booked,
  commission,
  commissionShow,
  rent,
  nseCash,
  userType,
  trade,
}) {
  /** ------------------ CARD STYLE ------------------ **/
  const cardStyle = {
    minWidth: "120px",
    padding: "6px 12px",
    borderRadius: "8px",
    background: "var(--background)",
    border: "2px solid var(--hover)",
    color: "var(--text)",
    display: "flex",
    flexDirection: "column",
  };

  const labelStyle = {
    fontSize: "0.7rem",
    opacity: 0.7,
    fontWeight: 500,
  };

  const valueStyle = {
    fontSize: "0.8rem",
    fontWeight: 700,
  };

  /** ------------------ BUY / SELL / NET QTY ------------------ **/
  const totalBuyQty =
    trade
      ?.filter((t) => t.buy_sell === 0)
      .reduce((sum, t) => sum + Number(t.qty || 0), 0) || 0;

  const totalSellQty =
    trade
      ?.filter((t) => t.buy_sell === 1)
      .reduce((sum, t) => sum + Number(t.qty || 0), 0) || 0;

  const netQty = totalBuyQty - totalSellQty;

  /** ------------------ AGGREGATION BY SYMBOL ------------------ **/
  const symbolStats = {};

  trade?.forEach((t) => {
    const symbol = t.symbol;
    const qty = Number(t.qty || 0);
    const pl = Number(t.profit_loss || 0);

    if (!symbolStats[symbol]) {
      symbolStats[symbol] = { qty: 0, profit: 0, loss: 0, trades: 0 };
    }

    // qty count
    symbolStats[symbol].qty += qty;

    // number of trades count
    symbolStats[symbol].trades += 1;

    // profit/loss split
    if (pl >= 0) {
      symbolStats[symbol].profit += pl;
    } else {
      symbolStats[symbol].loss += pl; // negative
    }
  });

  /** ------------------ MOST TRADABLE SYMBOL (BY NUMBER OF TRADES) ------------------ **/
  const mostTradable =
    Object.entries(symbolStats).sort((a, b) => b[1].trades - a[1].trades)[0] ||
    null;

  /** ------------------ MOST PROFITABLE SYMBOL ------------------ **/
  const mostProfit =
    Object.entries(symbolStats)
      .filter(([sym, val]) => val.profit > 0)
      .sort((a, b) => b[1].profit - a[1].profit)[0] || null;

  /** ------------------ MOST LOSS SYMBOL ------------------ **/
  const mostLoss =
    Object.entries(symbolStats)
      .filter(([sym, val]) => val.loss < 0)
      .sort((a, b) => a[1].loss - b[1].loss)[0] || null; // more negative = bigger loss

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        padding: "10px 20px",
        background: "var(--background)",
        color: "var(--text)",
        borderBottom: "1px solid var(--hover)",
      }}
    >
      {/* TOTAL P/L */}
      <div style={cardStyle}>
        <span style={labelStyle}>BOOKED</span>
        <span
          style={{
            ...valueStyle,
            color: booked >= 0 ? "var(--buy)" : "var(--sell)",
          }}
        >
          {fmt.format(parseFloat(booked).toFixed(0))}
        </span>
      </div>

      <div style={cardStyle}>
        <span style={labelStyle}>COMMISSION</span>
        <span style={{ ...valueStyle, color: "var(--sell)" }}>
          {fmt.format(parseFloat(commission).toFixed(0))}
        </span>
      </div>

      {/* RENT (only for NSE-Cash users) */}
      {nseCash === 1 && (
        <div style={cardStyle}>
          <span style={labelStyle}>RENT</span>
          <span style={{ ...valueStyle, color: "var(--sell)" }}>
            {fmt.format(parseFloat(rent).toFixed(0))}
          </span>
        </div>
      )}

      {/* ------------------ MOST TRADABLE SYMBOL ------------------ */}
      {mostTradable && (
        <div style={cardStyle}>
          <span style={labelStyle}>MOST TRADED</span>
          <span style={valueStyle}>
            {mostTradable[0]} ({mostTradable[1].trades})
          </span>
        </div>
      )}

      {/* ------------------ MOST PROFITABLE SYMBOL ------------------ */}
      {mostProfit && (
        <div style={cardStyle}>
          <span style={labelStyle}>TOP PROFIT</span>
          <span style={{ ...valueStyle, color: "var(--buy)" }}>
            {mostProfit[0]} (
            {fmt.format(parseFloat(mostProfit[1].profit).toFixed(0))})
          </span>
        </div>
      )}

      {/* ------------------ MOST LOSS SYMBOL ------------------ */}
      {mostLoss && (
        <div style={cardStyle}>
          <span style={labelStyle}>TOP LOSS</span>
          <span style={{ ...valueStyle, color: "var(--sell)" }}>
            {mostLoss[0]} ({fmt.format(parseFloat(mostLoss[1].loss).toFixed(0))}
            )
          </span>
        </div>
      )}

      {/* ------------------ BUY / SELL / NET QTY ------------------ */}
      {userType !== 4 && (
        <div style={{ marginLeft: "auto", display: "flex", gap: "16px" }}>
          <div style={cardStyle}>
            <span style={labelStyle}>BUY QTY</span>
            <span style={{ ...valueStyle, color: "var(--buy)" }}>
              {fmt.format(totalBuyQty.toFixed(2))}
            </span>
          </div>

          <div style={cardStyle}>
            <span style={labelStyle}>NET QTY (B - S)</span>
            <span style={{ ...valueStyle, color: "var(--primary)" }}>
              {fmt.format(netQty.toFixed(2))}
            </span>
          </div>

          <div style={cardStyle}>
            <span style={labelStyle}>SELL QTY</span>
            <span style={{ ...valueStyle, color: "var(--sell)" }}>
              {fmt.format(totalSellQty.toFixed(2))}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
